import { StoreMessageSelector } from './StoreMessageSelector';

export const findLocale = (locale, storeId) => {
  const messages = StoreMessageSelector(storeId);

  try {
    const regexObj = new RegExp(locale, 'g');
    const fullMatch = Object.keys(messages).find((e) => e.match(regexObj));
    const langWithoutRegion = locale.split('-')[0];
    const partialMatch = Object.keys(messages).find((e) =>
      e.includes(langWithoutRegion)
    );
    return fullMatch ? fullMatch : partialMatch ? partialMatch : 'en-GB';
  } catch (e) {
    return 'en-GB';
  }
};
